import Vue from 'vue';
import Cookie from 'js-cookie';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'manage',
      component: () =>
        import(/* webpackChunkName: "manage" */ './views/Manage.vue'),
      beforeEnter: (to, from, next) => {
        if (!Cookie.get('token')) {
          router.push('/login');
        }
        next();
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/phone-login',
      component: () => import('./views/PhoneLogin.vue'),
      hidden: true
    },
    {
      path: '/reset-password',
      component: () =>
        import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue'),
      children: [
        {
          path: '',
          component: () =>
            import(/* webpackChunkName: "reset-password" */ './components/account/PhoneCode.vue')
        }
      ]
    },
    {
      path: '/print/:u_id/a4',
      props: true,
      component: () => import('./views/printA4'),
      hidden: true
    },
    {
      path: '/print/:u_id/a5',
      props: true,
      component: () => import('./views/printA5'),
      hidden: true
    },
    {
      path: '/print/:u_id/tip',
      props: true,
      component: () => import('./views/printTip'),
      hidden: true
    },
    {
      path: '/introduce',
      component: () => import('./views/introducePage'),
      hidden: true
    }
  ]
});

export default router;
